<div class="esign-block">
  <div class="esign-block-status">
    <span class="esign-status-icon" [class.esign-status-icon--done]="isCompleted()" aria-hidden="true">
      <aiwyn-icon [name]="isCompleted() ? 'check' : 'edit'" [height]="16" [width]="16"></aiwyn-icon>
    </span>

    <div class="esign-status-copy">
      <p class="esign-status-title" [dataSelector]="'cxp-esign-status-title'">{{ statusTitle() }}</p>
      <p class="esign-status-subtitle" [dataSelector]="'cxp-esign-status-subtitle'">{{ statusSubtitle() }}</p>
    </div>

    <div class="esign-status-actions">
      @if (isCompleted()) {
        <button
          andButton
          color="default"
          size="small"
          [disabled]="!signedFileUrl()"
          [dataSelector]="'cxp-esign-view-document'"
          (click)="viewDocument.emit()"
        >View Document</button>

        <!--
          The signed PDF is built asynchronously after the last signer commits, so
          the bundle reads complete for a window in which the file does not exist
          yet. The action stays on the page throughout, disabled until the URL
          arrives — hiding it reads as the download having gone missing.
        -->
        @if (signedFileUrl(); as url) {
          <a
            class="esign-download"
            [href]="url"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download signed document"
            [dataSelector]="'cxp-esign-download'"
          >
            <aiwyn-icon name="download" [height]="16" [width]="16"></aiwyn-icon>
          </a>
        } @else {
          <!--
            A span, not a disabled button: the tooltip directive opens on mouseenter,
            and a disabled button fires no mouse events, so the explanation would
            never appear on the one state that needs it.
          -->
          <span
            class="esign-download esign-download--pending"
            [tooltip]="downloadPendingMessage"
            position="above"
            aria-disabled="true"
            [attr.aria-label]="downloadPendingMessage"
            [dataSelector]="'cxp-esign-download-pending'"
          >
            <aiwyn-icon name="download" [height]="16" [width]="16"></aiwyn-icon>
          </span>
        }
      } @else {
        <button
          andButton
          color="primary"
          size="small"
          [dataSelector]="'cxp-esign-review-and-sign'"
          (click)="reviewAndSign.emit()"
        >Review &amp; Sign</button>
      }
    </div>
  </div>

  @for (signer of signers(); track signer.key) {
    <div class="esign-signer-row" [dataSelector]="'cxp-esign-signer-row'">
      <span class="esign-signer-avatar" aria-hidden="true">{{ initialsFor(signer) }}</span>

      <div class="esign-signer-identity">
        <span class="esign-signer-name">{{ signer.displayName }}</span>
        @if (signer.email; as email) {
          <span class="esign-signer-email">{{ email }}</span>
        }
      </div>

      <pill
        size="small"
        [color]="signer.signed ? 'green' : 'yellow'"
        [value]="signer.signed ? 'Signed' : 'Pending'"
        [dataSelector]="'cxp-esign-signer-status'"
      ></pill>
    </div>
  }
</div>
